import { useEffect, useState } from "react";

import { Classes } from "@blueprintjs/core";
import NiceAvatar, { AvatarConfig } from "react-nice-avatar";

import quotesIcon from "@/../../hypetrain/static/img/quotes.svg";
import { EmbedSvg } from "@/components/helpers/ui/EmbedSvg";
import { Box, Flex } from "@/components/layout/flexbox";
import { StarRating } from "@/components/pages_flexible/coach/StarRating";
import { Masonry } from "@/components/pieces/marketing/Masonry";
import { Avatar } from "@/components/pieces/users/Avatar";
import { LIGHT_BACKGROUND } from "@/css/constants";
import { Testimonial } from "@/types/marketing";

interface QuoteGridProps {
  quotes: Testimonial[];
  backgroundColor?: string;
}

export function QuoteGrid({
  quotes,
  backgroundColor = LIGHT_BACKGROUND,
  ...htmlProps
}: QuoteGridProps) {
  return (
    <Masonry {...htmlProps}>
      {quotes.map((item, i) => {
        const { quote, name, photo, noPhoto, location, avatarConfig, type } =
          item;
        return (
          <div
            key={i}
            style={{
              backgroundColor: backgroundColor,
              borderRadius: 10,
              margin: 20,
              minWidth: 350,
            }}
          >
            <Box px={4} pt={4} pb={3} style={{ opacity: 0.4 }}>
              {type === "quotes" ? (
                <EmbedSvg src={quotesIcon} />
              ) : (
                <StarRating size={28} score={5} />
              )}
            </Box>
            <Box
              px={4}
              className={Classes.RUNNING_TEXT}
              style={{ fontSize: 18 }}
            >
              {quote}
            </Box>
            <Flex alignItems="center" p={4} my={2}>
              {!noPhoto && photo && (
                <QuoteAvatar authorPhoto={photo} avatarConfig={avatarConfig} />
              )}
              <Box pl={noPhoto ? 0 : 2}>
                <b>{name}</b>
                <Box>{location}</Box>
              </Box>
            </Flex>
          </div>
        );
      })}
    </Masonry>
  );
}

interface QuoteAvatarProps {
  authorPhoto: string;
  avatarConfig?: AvatarConfig;
}

export function QuoteAvatar({ authorPhoto, avatarConfig }: QuoteAvatarProps) {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    setLoaded(true);
  }, []);

  if (!loaded) {
    return <Box width={48} height={48} style={{ borderRadius: "100%" }}></Box>;
  }

  return (
    <Box width={48} height={48} style={{ borderRadius: "100%" }}>
      {authorPhoto ? (
        <Avatar user={{ photo: authorPhoto }} size={48} />
      ) : (
        typeof window !== "undefined" && (
          <NiceAvatar style={{ width: 48, height: 48 }} {...avatarConfig} />
        )
      )}
    </Box>
  );
}
